import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import BannerNewsItem from "../../components/BannerNewsItem";
import { getContent } from "../../utils/main";
import * as Icon from "react-bootstrap-icons";
import ContentLoader from "react-content-loader";

const Articles = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [buttonShow, setButtonShow] = useState(true);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(4);
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [word, setWord] = useState("");
  const [date, setDate] = useState("");

  const _fetchPosts = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/posts/all-articles/?size=${size}&page=${page}&word=${word}&date=${date}`
      )
      .then((res) => {
        if (count === 0) setCount(res.data.count);
        if (page === 1) {
          setPosts([...[], ...res.data.results]);
        } else {
          setPosts([...posts, ...res.data.results]);
        }
      })
      .catch((res) => {
        if (res.response.status === 404) {
          setButtonShow(false);
        }
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setSize(4);
    _fetchPosts();
  }, [page]);

  const _handleSearch = () => {
    setButtonShow(true);
    setPage(1);
    _fetchPosts();
  };
  return (
    <div className="posts-wrapper py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4
              className="articles-page-title"
              style={{
                textAlign: "left !important",
                fontSize: "24px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              {getContent(content, "Articles", lang)}
            </h4>
          </div>
        </div>
        <div className="row mobile-reverse">
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            {posts.length === 0
              ? ""
              : posts.map((post) => (
                  <BannerNewsItem post={post} type="posts" key={post.id} />
                ))}
            {buttonShow === true ? (
              isLoading === true ? (
                <div>
                  <ContentLoader viewBox="0 0 306 45" className="bra5">
                    <rect x="0" y="0" rx="0" ry="0" width="80%" height="10" />
                    <rect x="0" y="13" rx="0" ry="0" width="20%" height="8" />
                    <rect x="0" y="24" rx="0" ry="0" width="100%" height="14" />
                  </ContentLoader>
                  <ContentLoader viewBox="0 0 306 45" className="bra5">
                    <rect x="0" y="0" rx="0" ry="0" width="80%" height="10" />
                    <rect x="0" y="13" rx="0" ry="0" width="20%" height="8" />
                    <rect x="0" y="24" rx="0" ry="0" width="100%" height="14" />
                  </ContentLoader>
                </div>
              ) : (
                <button
                  className="black-btn clear-btn px-4"
                  onClick={() => {
                    setPage(page + 1);
                  }}
                >
                  {getContent(content, "Load more", lang)}
                </button>
              )
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="mb-4 floating-label">
              <input
                type="text"
                name="word"
                className="form-control"
                placeholder=" "
                required
                onChange={(e) => {
                  setWord(e.target.value);
                }}
              />
              <label htmlFor="text">
                {getContent(content, "Search", lang)} *
              </label>
            </div>
            <div className="mb-3 floating-label">
              <input
                type="date"
                name="date"
                className="form-control"
                placeholder=" "
                required
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />
              <label htmlFor="date">
                {getContent(content, "Date", lang)} *
              </label>
            </div>
            <div className="mb-4">
              <button
                className="black-btn clear-btn px-5 w-100"
                onClick={() => _handleSearch()}
              >
                {getContent(content, "Search", lang)} &nbsp; <Icon.Search />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;
